import { getConfig } from '@/app/config'
import type { GlobalWidget } from '@/app/widgets'

/**
 * The top-bar timer (docs/projects/BRIEF.md PM-3, PLAN.md §2 "Top bar: global stopwatch"): a global widget, so a
 * running timer stays in view across pages. Shown in the `pm` software only for now (the employee's side, `em`, comes
 * with PM-4), on the classic layout (the navbar it sits in), behind the beta flag like the module's routes; Client and
 * Staff — the users of `pm`.
 */
const widgets: GlobalWidget[] = [
  {
    id: 'projects-timer',
    load: () => import('./components/time/TimerWidget.vue'),
    when: ({ signedIn, userType, software, layout }) =>
      signedIn &&
      getConfig().betaFeature &&
      software === 'pm' &&
      layout === 'vertical' &&
      (userType === 'Client' || userType === 'Staff'),
  },
]

export default widgets
